module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content page"
  }, [(_vm.page) ? _c('div', {
    class: !_vm.loading ? '' : 'loading'
  }, [_c('hero', {
    attrs: {
      "id": "show",
      "page": _vm.page
    }
  }), _vm._v(" "), (_vm.page.awards) ? _c('awards', {
    attrs: {
      "awards": _vm.page.awards
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page.awards) ? _c('press', {
    attrs: {
      "id": "press",
      "items": _vm.page.awards.items
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page.contact) ? _c('contact', {
    attrs: {
      "id": "contact",
      "contact": _vm.page.contact
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page.team) ? _c('the-team', {
    attrs: {
      "id": "team",
      "team": _vm.page.team
    }
  }) : _vm._e(), _vm._v(" "), _c('shop-module')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f9e625"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 767
// module chunks = 1